import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {DeliveriesService} from "../../services/deliveries-service.service";

export class ServicesAutoAssignRelatedServicesDialogViewCtrl implements IController {
  serviceIds: string[];
  relatedServicesIds: string[];
  onAssignableServicesChanged: Function;

  public assignRelatedChecked: boolean;
  public assignableServices: any;
  public unAssignableServices: any;


  private deliveriesRef: any;


  /* @ngInject */
  constructor(private $delivery, private deliveriesService: DeliveriesService) {
    this.deliveriesRef = this.$delivery();
  }

  $onInit() {
    this.assignableServices = [];
    this.unAssignableServices = [];
    this.assignRelatedChecked = true;

  }

  $onChanges(changes) {
    if (changes.serviceIds
      || changes.relatedServicesIds) {
      this._setRelations(this.relatedServicesIds);
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  onAssignServicesToggled() {
    this.assignRelatedChecked = !this.assignRelatedChecked ;
    const assignableServicesIds = _.map(this.assignableServices, (s) => {
      return s.id
    })
    this.assignRelatedChecked ? this.onAssignableServicesChanged({assignableServicesIds: assignableServicesIds}) : this.onAssignableServicesChanged({assignableServicesIds: []})
  }


  private _setRelations(relatedServicesIds: string[]): void {

    return this.deliveriesRef.$asyncValues(relatedServicesIds)
      .then((relatedServices) => {
        this.assignableServices = relatedServices.filter((relatedService) => {
          const pickupTask = _.find(relatedService.taskList, (t) => {
            return t.taskSpec.purpose === "Pickup"
          })
          return !(relatedService.status == "Completed"
            || relatedService.status == "Canceled"
            || (relatedService.status == "Aborted" && pickupTask.status === "Canceled"));
        });
        if (this.assignRelatedChecked) {
          const assignableServicesIds = _.map(this.assignableServices, (s) => {
            return s.id
          })
          this.onAssignableServicesChanged({assignableServicesIds: assignableServicesIds});
        }

        this.unAssignableServices = _.differenceBy(relatedServices, this.assignableServices);
      });

  }
}

angular.module('bringoz.admin.deliveries').component('servicesAutoAssignRelatedServicesDialogView', {
  bindings: {
    serviceIds: '<',
    relatedServicesIds: '<?',
    onAssignableServicesChanged: '&'
  },
  template: require('./services-auto-assign-related-services-dialog-view.html').default,
  controller: ServicesAutoAssignRelatedServicesDialogViewCtrl
});
